import React, { ChangeEvent, useCallback, useEffect, memo, useRef } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import { IconButton, InputBase, InputAdornment, Collapse, Box } from '@material-ui/core';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import { useStyles } from './cardapio-barra-pesquisa-styles';
import { useFuncoesNavbarStore } from 'services/store/funcoes-navbar';

export interface CardapioBarraPesquisaProps {
  pesquisa: boolean;
  modo?: 'static' | 'dinamic';
  quandoPesquisar?: (event: ChangeEvent<HTMLInputElement>) => any;
  onPesquisaClick?: () => any;
  fixo?: boolean
  isPedidoLocal?: boolean
}

export const CardapioBarraPesquisa = ({
  pesquisa,
  modo,
  onPesquisaClick,
  quandoPesquisar,
  fixo,
  isPedidoLocal
}: CardapioBarraPesquisaProps) => {

  // DEPENDENCIAS
  const classes = useStyles({ modo, fixo, isPedidoLocal });

  // REFS
  const inputNumeroRef = useRef<HTMLDivElement | null>(null);
  const setTermoPesquisa = useFuncoesNavbarStore((state) => state.setTermoPesquisa);

  const cancelSearch = useCallback(() => {
    if (setTermoPesquisa) setTermoPesquisa('');
    if (onPesquisaClick && modo !== 'static') onPesquisaClick();
  }, [setTermoPesquisa, onPesquisaClick, modo]);

  useEffect(() => {
    if (pesquisa) {
      inputNumeroRef?.current?.focus();
    }
  }, [pesquisa]);

  return (
    <>
      <Box display={"flex"} justifyContent="center" width={!fixo ? '100%' : 'auto'}>
        <Collapse in={fixo || pesquisa} mountOnEnter unmountOnExit style={{
          width: "100%",
          maxWidth: !fixo ? '100%' : 600,
          flex: 1
        }}>
          <div className={classes.searchBarContainer}>
            <InputBase
              inputRef={inputNumeroRef}
              className={classes.searchBar}
              value={useFuncoesNavbarStore((state) => state.termoPesquisa)}
              onChange={quandoPesquisar}
              startAdornment={
                <InputAdornment position="start">
                  <SearchRoundedIcon className={classes.searchIcon} />
                </InputAdornment>
              }
              classes={{
                input: classes.input,
                root: classes.inputRoot,
              }}
              placeholder="Buscar produto"
            />
            {pesquisa && (
              <IconButton
                onClick={cancelSearch}
                aria-label="pesquisar"
                aria-haspopup="true"
                className={classes.cancelSearchIcon}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            )}
          </div>
        </Collapse>
      </Box>
    </>
  );
};
export const BarraPesquisa = memo(CardapioBarraPesquisa);
